import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer className="page-footer">
                <div className="footer-copyright">
                    <div className="container">
                        © {new Date().getFullYear()} Copyright Text
                        <a className="grey-text text-lighten-4 right" href="tel:+998996277727">Tell: +99899 627 77 27</a>
                        <a className="grey-text text-lighten-4 right" href="uchqunjonturdiev@gmail.com">Email: uchqunjonturdiev@gmail.com</a>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default Footer;